module.exports = __webpack_public_path__ + "img/sailing-shipyard.31f156b1.webp";